import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section hector-earth-zone">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-logo">
              <h3>Hector Díaz</h3>
              <p className="footer-tagline">Master Artist & Community Visionary</p>
            </div>

            <div className="footer-quote">
              <blockquote>
                "Art has the power to transform not just the canvas, but the soul of a community"
              </blockquote>
              <cite>— Hector Díaz</cite>
            </div>
          </div>

          <div className="footer-sections">
            <div className="footer-column">
              <h4>Legacy Programs</h4>
              <ul>
                <li>New DAY - Diaz Art for Youth</li>
                <li>Downtown Gallery Initiative</li>
                <li>Community Art Workshops</li>
                <li>Mentorship Programs</li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Recognition</h4>
              <ul>
                <li>City of Destiny Award</li>
                <li>Community Leadership Honor</li>
                <li>Arts Education Excellence</li>
                <li>Cultural Impact Award</li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Media Features</h4>
              <ul>
                <li>Sound Life Magazine</li>
                <li>The News Tribune</li>
                <li>Tacoma City Paper</li>
                <li>Channel 11 News</li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Artistic Vision</h4>
              <ul>
                <li>Art of the Future Collection</li>
                <li>Nocturnal Landscapes</li>
                <li>Celestial Compositions</li>
                <li>Community Murals</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-tribute">
          <div className="tribute-content">
            <h4>Celebrating a Living Legacy</h4>
            <p>
              This website celebrates Hector Díaz's extraordinary life and ongoing impact
              on the Tacoma community. His vision continues to inspire artists, educators, and
              community leaders around the Pacific Northwest.
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Hector Díaz Biography. Created with love and respect for his legacy.</p>
            <div className="footer-navigation">
              <a href="#home">Home</a>
              <a href="#biography">Biography</a>
              <a href="#videos">Videos</a>
              <a href="#timeline">Timeline</a>
              <a href="#gallery">Gallery</a>
              <a href="#legacy">Legacy</a>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="footer-decorations">
        <div className="footer-horizon-line"></div>
        <div className="footer-stars">
          {[...Array(15)].map((_, i) => (
            <div
              key={i}
              className="footer-star"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
              }}
            />
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;